<script>
    import {getObjects, getObj, saveObj} from '../lib/data.js';
    import {notifier} from '@beyonk/svelte-notifications';
    import {push} from 'svelte-spa-router';

    import Editor from '../Forms/Editor.svelte';
    import Field from '../Forms/Field.svelte';

    export let params;

    let table = {
        name: '',
        data: {
            rows: 3,
            cols: 4,
            row_styles: {},
            col_styles: {},
            cell_styles: {},
            conditional_formatting: {},
            values: {},
            merge: []
        }
    }

    let iterator = Array(12);
    let highlight = [0, 0];
    let showCells = false;
    let cellsTop = 0;
    let cellsLeft = 0;
    let selected_rows = 0;
    let selected_cols = 0;

    let cellContents;
    let showEditor = false;
    let editor;

    let showConditionalFormatting = false;
    let conditionalFormattingRules = [];

    let selection_start;
    let selection_end;
    let drag = false;

    let transform_loader = getObjects("transform")

    let background_color = "#000000";
    let font_color = "#000000";

    function setHighlight() {
        highlight = [this.dataset.rows, this.dataset.cols];

        selected_rows = this.dataset.rows;
        selected_cols = this.dataset.cols;

        iterator = iterator;
    }

    function toggleCells(evt) {
        cellsTop = evt.clientY;
        cellsLeft = evt.clientX;

        showCells = !showCells;
    }

    function clearSelection(evt) {
        if (evt.target == this) {
            selection_start = selection_end = undefined;
        }
    }

    function iterate(size, start) {
        if (start == undefined) start = 0;
        return [...Array(size).keys()].map((i) => i + start);
    }

    function setTableSize() {
        table.data.rows = parseInt(this.dataset.rows);
        table.data.cols = parseInt(this.dataset.cols);
    }

    function setMerge() {
        for (let row = selection_start[0]; row <= selection_end[0]; row++) {
            for (let col = selection_start[1]; col <= selection_end[1]; col++) {
                let merge = getMerge(row, col);
                if (merge != undefined) {
                    table.data.merge = table.data.merge.filter((m) => m != merge);
                }
            }
        }
        if (selection_start.join()  != selection_end.join()) {
            table.data.merge = [...table.data.merge, {start: selection_start, end: selection_end}];
            selection_end = selection_start;
        }
    }

    function setWidth() {
        let width = prompt("Column Width (inches)");

        if (width != null) {
            for (let col = selection_start[1]; col <= selection_end[1]; col++) {
                let col_style = table.data.col_styles[col]
                if (col_style == undefined)
                    table.data.col_styles[col] = {};

                if (width != "") {
                    table.data.col_styles[col]['width'] = `${width}in`;
                } else {
                    delete table.data.col_styles[col]['width']
                }
            }
            table.data.col_styles = table.data.col_styles;
        }
    }

    function setHeight() {
        let height = prompt("Row Height (inches)");

        if (height != null) {
            for (let row = selection_start[0]; row <= selection_end[0]; row++) {
                let row_style = table.data.row_styles[row]
                if (row_style == undefined)
                    table.data.row_styles[row] = {};

                if (height != "") {
                    table.data.row_styles[row]['height'] = `${height}in`;
                } else {
                    delete table.data.row_styles[col]['height']
                }
            }
            table.data.row_styles = table.data.row_styles;
        }
    }

    function setStyle(style) {
        for (let row = selection_start[0]; row <= selection_end[0]; row++) {
            for (let col = selection_start[1]; col <= selection_end[1]; col++) {
                console.log(row, col);
                if (table.data.cell_styles[[row,col]] == undefined) table.data.cell_styles[[row,col]] = {}

                switch (style) {
                    case ("bold"):
                        table.data.cell_styles[[row,col]]["font-weight"] = "bold"
                        break
                    case ("italic"):
                        table.data.cell_styles[[row,col]]["font-style"] = "italic"
                        break
                    case ("underline"):
                        table.data.cell_styles[[row,col]]["text-decoration"] = "underline"
                        break
                }

                console.log(table);
            }
        }
    }

    function setBackgroundColor() {
        if (selection_start == undefined) return alert("No Selection Found");

        for (let row = selection_start[0]; row <= selection_end[0]; row++) {
            for (let col = selection_start[1]; col <= selection_end[1]; col++) {
                if (table.data.cell_styles[[row,col]] == undefined) table.data.cell_styles[[row,col]] = {}
                table.data.cell_styles[[row,col]]["background-color"] = background_color;
            }
        }
    }

    function setFontColor() {
        if (selection_start == undefined) return alert("No Selection Found");

        for (let row = selection_start[0]; row <= selection_end[0]; row++) {
            for (let col = selection_start[1]; col <= selection_end[1]; col++) {
                if (table.data.cell_styles[[row,col]] == undefined) table.data.cell_styles[[row,col]] = {}
                table.data.cell_styles[[row,col]]["color"] = font_color;
            }
        }
    }

    function clearFormatting() {
        if (selection_start == undefined) return alert("No Selection Found");

        for (let row = selection_start[0]; row <= selection_end[0]; row++) {
            for (let col = selection_start[1]; col <= selection_end[1]; col++) {
                delete table.data.cell_styles[[row,col]]
            }
        }
        table.data.cell_styles = table.data.cell_styles
    }

    function isSelected(row, col) {

        if (selection_start != undefined && selection_end != undefined) {
            return ((selection_start[0] <= row)  && (row <= selection_end[0]) && (selection_start[1] <= col) && (col <= selection_end[1]));
        }

        return false
    }

    function getMerge(row, col) {
        for (let merge of table.data.merge) {
            if (merge.start[0] <= row && merge.end[0] >= row && merge.start[1] <= col && merge.end[1] >= col) {
                return merge
            }
        }
    }

    function generateTable(table) {
        let generated_table = [];
        for (let row = 0; row < table.data.rows; row++) {
            let generated_row = [];
            for (let col = 0; col < table.data.cols; col++){
                let generated_column = {
                    row: row,
                    col: col,
                    style: "",
                    selected: isSelected(row,col),
                    spans: {}
                }

                // get merged cells
                let merge = getMerge(row, col);
                if (merge != undefined) {
                    if (row == merge.start[0] && col == merge.start[1]) {
                        generated_column.spans.rowspan = merge.end[0] - merge.start[0] + 1;
                        generated_column.spans.colspan = merge.end[1] - merge.start[1] + 1;
                    } else {
                        continue
                    }
                }

                // get row styles
                let row_style = table.data.row_styles[row];
                if (row_style != undefined) {
                    for (let style in row_style) {
                        generated_column.style += `${style}: ${row_style[style]};`;
                    }
                }

                // get column styles
                let col_style = table.data.col_styles[col];
                if (col_style != undefined) {
                    for (let style in col_style) {
                        generated_column.style += `${style}: ${col_style[style]};`;
                    }
                }

                // get cell styles
                let cell_style = table.data.cell_styles[[row, col]];
                if (cell_style != undefined) {
                    for (let style in cell_style) {
                        generated_column.style += `${style}: ${cell_style[style]};`;
                    }
                }
                // get cell contents
                generated_column.content = table.data.values[[row,col]] ? table.data.values[[row,col]] : "[[empty]]";

                generated_row.push(generated_column);
            }
            generated_table.push(generated_row)
        }

        return generated_table;
    }

    function startSelection() {
        selection_start = [parseInt(this.dataset.row), parseInt(this.dataset.col)];
        selection_end = [parseInt(this.dataset.row), parseInt(this.dataset.col)];
        drag = true;
    }

    function expandSelection() {
        if (!drag) return;

        selection_end = [parseInt(this.dataset.row), parseInt(this.dataset.col)];

        return false;
    }

    function endSelection() {
        drag = false;
    }

    function editContents() {
        cellContents = table.data.values[selection_start];
        if (cellContents == undefined) cellContents = "";

        showEditor = true;
    }

    function updateCellContents() {
        table.data.values[selection_start] = cellContents;
        showEditor = false;
    }

    function showConditionalFormattingModal() {
        conditionalFormattingRules = table.data.conditional_formatting[selection_start];
        conditionalFormattingRules = conditionalFormattingRules ? conditionalFormattingRules : [];

        showConditionalFormatting = true;
    }

    function addRule() {
        conditionalFormattingRules = [...conditionalFormattingRules, {
            condition: "",
            bold: false,
            italic: false,
            underline: false,
            background: "#ffffff",
            font: "#000000"
        }]
    }

    function deleteRule(rule) {
        conditionalFormattingRules = conditionalFormattingRules.filter((r) => r != rule);
    }

    function saveRules() {
        table.data.conditional_formatting[selection_start] = conditionalFormattingRules;
        showConditionalFormatting = false;
    }

    async function getTable(id) {
        table = await getObj("table", id)
    }

    async function saveTable() {
        table = await saveObj("table", table);
        notifier.success("Table Saved");
        push('/findings/templates/')
    }

    $: getTable(params.id)

    $: render_table = generateTable(table, selection_start, selection_end);
</script>
<style>
    .cells {
        background: white;
        overflow: auto;
        width: max-content;
        position: absolute;

    }
    .cell {
        border: 1px solid #aaa;
        height: 16px;
        width: 16px;
        margin: 0 1px 1px 0;
        float: left;
        cursor: pointer;
        z-index: 101;
    }

    .cell.highlight {
        background-color: gray;
    }

    .row {
        clear: both;
    }

    .hidden {
        display: none;
    }

    .cell_container {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vh;
        z-index: 100;
    }

    .table {
        color: black;
        background-color: white;
        border: 1px solid #dbdbdb;
    }

    .selected {
        border: 2px dotted blue !important;
    }

    .preview td {
        cursor: pointer;
        border: 1px solid #dbdbdb;
        height: 2em;
        user-select: none;
    }

    .button.color {
        height: 1.5em;
        width: 1.5em;
        padding: 0;
        margin-right: 1em;
    }

    .empty {
        color: white;
    }

    .preview {
        overflow: unset;
    }

    .modal-card {
        width: 11in;
    }

    #toolbarTop {
        width: 8.5in;
        margin: auto;
    }

    .field {
        width: 8.5in;
        margin: auto;
        margin-bottom: 10px;
    }

    .modal td {
        text-align: center;
        vertical-align: middle;
    }

    @media (min-width: 1560px) {
        .column.is-2 {
            margin-right: -16.66667%;
        }
    }
</style>
<form on:submit|preventDefault={saveTable}>
    <h1 class="title is-1">
    Findings Table
    <button class="button is-success is-pulled-right">Save</button>
    </h1>

    <div class="columns">
        <div class="column is-2">
            <div class="menu">
                <p class="menu-label">Transform Reference</p>
                <ul class="menu-list">
                    {#await transform_loader}
                        Loading...
                    {:then transforms}
                        <li>
                        Transforms
                        <ul>
                        {#each transforms as transform}
                            <li>
                                {transform.name}
                                <ul>
                                    <li>
                                        Transform Fields
                                        <ul>
                                        {#each transform.transforms.sort((a, b) => a.name > b.name) as transform_field}
                                            <li>{transform_field.name}</li>
                                        {/each}
                                        </ul>
                                    </li>
                                    <li>
                                        Extract Fields
                                        <ul>
                                            {#each transform.extractions.sort((a,b) => a.name > b.name) as extract_field}
                                                <li>{extract_field.name}</li>
                                            {/each}
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        {/each}
                        </ul>
                        </li>
                    {/await}
                </ul>
            </div>
        </div>
        <div class="column">
            <div class="field">
                <Field name="Table Name" label="Table Name" bind:value={table.name} required />
            </div>
            <div class="field has-addons">
                <p class="control">
                    <button class="button" on:click={toggleCells}>
                        <span class="icon is-small">
                            <i class="fas fa-table"></i>
                        </span>
                        <span>Table Size</span>
                    </button>
                </p>
                <p class="control">
                    <span class="button" on:click={setMerge}>
                        <span class="icon is-small">
                            <i class="fas fa-compress"></i>
                        </span>
                        <span>Merge</span>
                    </span>
                </p>
                <p class="control">
                    <span class="button" on:click={setWidth}>
                        <span class="icon is-small">
                            <i class="fas fa-arrows-alt-h"></i>
                        </span>
                        <span>Column Width</span>
                    </span>
                </p>
                <p class="control">
                    <span class="button" on:click={setHeight}>
                        <span class="icon is-small">
                            <i class="fas fa-arrows-alt-v"></i>
                        </span>
                        <span>Row Height</span>
                    </span>
                </p>
            </div>
            <!--
            <div class="field has-addons has-text-centered">
                <p class="control">
                    <span class="button" on:click={() => setStyle("bold")}>
                        <span class="icon is-small">
                            <i class="fas fa-bold"></i>
                        </span>
                        <span>Bold</span>
                    </span>
                </p>
                <p class="control">
                    <span class="button" on:click={() => setStyle("italic")}>
                        <span class="icon is-small">
                            <i class="fas fa-italic"></i>
                        </span>
                        <span>Italic</span>
                    </span>
                </p>
                <p class="control">
                    <span class="button" on:click={() => setStyle("underline")}>
                        <span class="icon is-small">
                            <i class="fas fa-underline"></i>
                        </span>
                        <span>Underline</span>
                    </span>
                </p>
            </div>
            -->
            <div class="field has-addons">
                <p class="control">
                    <span class="button">
                        <span>
                            <input id="bg_color_button" class="button color" type="color" bind:value={background_color} on:change={setBackgroundColor}>
                        </span>
                        <span on:click={setBackgroundColor}>Background color</span>
                    </span>
                </p>
                <p class="control">
                    <span class="button">
                        <span>
                            <input id="font_color_button" class="button color" type="color" bind:value={font_color} on:change={setFontColor}>
                        </span>
                        <span on:click={setFontColor}>Font color</span>
                    </span>
                </p>
                <p class="control">
                    <span class="button" on:click={clearFormatting}>
                        <span class="icon is-small">
                            <i class="fas fa-broom"></i>
                        </span>
                        <span>Clear Formatting</span>
                    </span>
                </p>
                <p class="control">
                    <button type="button" class="button" on:click={showConditionalFormattingModal} disabled={!selection_start || selection_start.join() != selection_end.join()}>
                        <span class="icon is-small">
                            <i class="fas fa-calculator"></i>
                        </span>
                        <span>Conditional Formatting</span>
                    </button>
                </p>
            </div>

            <div class="preview" on:click={clearSelection}>
                <table class="table is-fullwidth">
                    <tbody>
                    {#each render_table as row}
                        <tr>
                            {#each row as col}
                                    <td
                                        class:selected = {col.selected}
                                        class:empty = {col.content == "[[empty]]"}
                                        on:mousedown = {startSelection}
                                        on:mouseup = {endSelection}
                                        on:mousemove = {expandSelection}
                                        on:dblclick = {editContents}
                                        data-row = {col.row}
                                        data-col = {col.col}
                                        {...col.spans}
                                        style={col.style}
                                    >
                                        {@html col.content}
                                    </td>
                            {/each}
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</form>

<div class="cell_container" class:hidden={!showCells} on:click={toggleCells}>
    <div class="cells" style="top: {cellsTop}px; left: {cellsLeft}px;">
        {#each iterator as row, i}
            <div class="row">
                {#each iterator as col, j}
                    <div class="cell" class:highlight={i+1 <= highlight[0] && j+1 <= highlight[1]} data-rows={i+1} data-cols={j+1} on:mouseover={setHighlight} on:click={setTableSize}>

                    </div>
                {/each}
            </div>
        {/each}
        {selected_rows} X {selected_cols}
    </div>
</div>

{#if showEditor}
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Edit Cell</p>
                <button class="delete" aria-label="close" on:click={() => showEditor = false}></button>
            </header>
            <section class="modal-card-body">
                <div id="toolbarTop"></div>
                <div class="preview" on:click={() => editor.focus()}>
                    <Editor bind:content={cellContents} bind:this={editor} wrap_p={false}></Editor>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" on:click={updateCellContents}>Save changes</button>
                <button class="button" on:click={() => showEditor = false}>Cancel</button>
            </footer>
        </div>
    </div>
{/if}

{#if showConditionalFormatting}
<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-content" style="width: 960px;">
        <div class="box">
            <h1 class='title is-2'>
                <span class="delete" on:click={() => showConditionalFormatting = false}></span>
                Conditional Formatting
                <span class="button is-pulled-right" on:click={addRule}>Add Rule</span>
            </h1>
            <table class="table is-fullwidth is-striped">
                <thead>
                    <tr>
                        <th>Condition <span class='is-size-7 is-pulled-right'> (Use value for cell contents)</th>
                            <th>Bold</th>
                            <th>Italic</th>
                            <th>Underline</th>
                            <th>Background Color</th>
                            <th>Font Color</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody id="formatting_rules">
                        {#each conditionalFormattingRules as rule}
                            <tr>
                                <td>
                                    <input type="text" bind:value={rule.condition} class="input">
                                </td>
                                <td>
                                    <input type="checkbox" bind:checked={rule.bold}>
                                </td>
                                <td>
                                    <input type="checkbox" bind:checked={rule.italic}>
                                </td>
                                <td>
                                    <input type="checkbox" bind:checked={rule.underline}>
                                </td>
                                <td>
                                    <input type="color" bind:value={rule.background}>
                                </td>
                                <td>
                                    <input type="color" bind:value={rule.font}>
                                </td>
                                <td>
                                    <span class="delete" on:click={() => deleteRule(rule)}></span>
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
                <span class="button is-pulled-right" on:click={saveRules}>Save</span>
                <br class="is-clearfix">
        </div>
    </div>
</div>
{/if}